import React from 'react';
import { Box } from '@mui/material';
import { selectedElement } from 'features/document/documentSlice';
import { isTableElement } from 'utils/typeGuards';
import { Title } from '../../Sidebar.styled';

interface TableSidebarProps {
  currentElement: selectedElement;
}

export default function TableSidebar({ currentElement }: TableSidebarProps) {
  const tableElement = currentElement.data;
  if (!isTableElement(tableElement)) {
    return null;
  }

  return (
    <Box alignItems={'flex-start'} display={'flex'} flexDirection={'column'}>
      <Title>Table Block</Title>
    </Box>
  );
}
